<div class="container-fluid app-shell">
  <div class="row flex-nowrap h-100">

    <!-- ===== SIDEBAR ===== -->
    <div class="sidebar-nav offcanvas-md offcanvas-start text-white px-0 flex-shrink-0"
         [class.sidebar-collapsed]="sidebarCollapsed"
         tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">

      <!-- Header offcanvas (solo móvil) -->
      <div class="offcanvas-header d-md-none border-bottom border-secondary sidebar-nav">
        <h6 class="offcanvas-title text-white" id="sidebarMenuLabel">{{user.affiliate.affiliateName}}</h6>
        <button type="button" class="btn-close btn-close-white"
                data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body d-flex flex-column px-3 pt-3 text-white">

        <!-- Brand + Toggle -->
        <div class="sidebar-brand-row d-flex align-items-center pb-3 mb-2 border-bottom border-secondary">
          <a routerLink="/dashboard"
             class="sidebar-brand-text d-flex align-items-center flex-grow-1 text-white text-decoration-none overflow-hidden">
            <div class="overflow-hidden">
              <div class="fs-6 fw-semibold text-truncate">{{user.affiliate.affiliateName}}</div>
              <div class="small opacity-75">
                @if(user.idUserRole == userrole_salesPerson) {
                  Sales System
                } @else {
                  Employer System
                }
              </div>
            </div>
          </a>
          <button class="btn sidebar-toggle-btn d-none d-md-flex flex-shrink-0"
                  (click)="toggleSidebar()"
                  [title]="sidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
            <i class="bi fs-5"
               [class.bi-chevron-double-right]="sidebarCollapsed"
               [class.bi-chevron-double-left]="!sidebarCollapsed"></i>
          </button>
        </div>

        <!-- Navigation -->
        <ul class="nav nav-pills flex-column flex-nowrap gap-1 flex-grow-1" id="menu">

          <!-- Dashboard — todos los roles -->
          <li class="nav-item">
            <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
               class="nav-link text-white d-flex align-items-center gap-2" title="Dashboard">
              <i class="bi bi-speedometer2 fs-5 flex-shrink-0"></i>
              <span>Dashboard</span>
            </a>
          </li>

          <!-- Pipeline + Payment Tracker — solo salespeople -->
          @if(user.idUserRole == userrole_salesPerson) {
          <li class="nav-item">
            <a routerLink="/pipeline" routerLinkActive="active"
               class="nav-link text-white d-flex align-items-center gap-2" title="Client Pipeline">
              <i class="bi bi-kanban fs-5 flex-shrink-0"></i>
              <span>Client Pipeline</span>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/seller/payments" routerLinkActive="active"
               class="nav-link text-white d-flex align-items-center gap-2" title="Payment Tracker">
              <i class="bi bi-wallet2 fs-5 flex-shrink-0"></i>
              <span>Payment Tracker</span>
            </a>
          </li>
          <!-- Admins: su entrada está en Operations (la vista de vendedor es solo lectura) -->
          @if (user.securityLevel != adminLevel) {
          <li class="nav-item">
            <a routerLink="/seller/site-leads" routerLinkActive="active"
               class="nav-link text-white d-flex align-items-center gap-2"
               [title]="availableLeads ? 'Employer Leads — ' + availableLeads + ' available' : 'Employer Leads'">
              <div class="position-relative flex-shrink-0 d-flex">
                <i class="bi bi-megaphone fs-5"></i>
                @if (availableLeads > 0 && sidebarCollapsed) {
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger leads-dot">{{ availableLeads > 99 ? '99+' : availableLeads }}</span>
                }
              </div>
              <span class="flex-grow-1">Employer Leads</span>
              @if (availableLeads > 0) {
                <span class="badge rounded-pill bg-danger leads-count">{{ availableLeads > 99 ? '99+' : availableLeads }}<span class="visually-hidden"> available</span></span>
              }
            </a>
          </li>
          }
          <li class="nav-item">
            <a routerLink="/seller/messages" routerLinkActive="active"
               class="nav-link text-white d-flex align-items-center gap-2" title="Messages">
              <i class="bi bi-envelope-fill fs-5 flex-shrink-0"></i>
              <span>Messages</span>
            </a>
          </li>
          }

          <!-- ── Employer ── -->
          @if(user.idUserRole == userrole_employer) {
            <li class="nav-section-label px-2 pt-2 pb-1">
              <button type="button" class="section-toggle d-flex align-items-center justify-content-between w-100"
                      (click)="toggleSection('company')" [attr.aria-expanded]="sectionsOpen.company">
                <small>My Company</small>
                <i class="bi section-chevron"
                   [class.bi-chevron-down]="sectionsOpen.company"
                   [class.bi-chevron-right]="!sectionsOpen.company"></i>
              </button>
            </li>
            @if (isSectionOpen('company')) {
              <li class="nav-item">
                <a routerLink="/manageEmployees" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Employee Enrollment">
                  <i class="bi bi-people fs-5 flex-shrink-0"></i>
                  <span>Employee Enrollment</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/employerPaymentList" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Payment History">
                  <i class="bi bi-receipt fs-5 flex-shrink-0"></i>
                  <span>Payment History</span>
                </a>
              </li>
            }
          }

          <!-- ── Admin: Operations ── -->
          @if(user.securityLevel == adminLevel) {
            <li class="nav-section-label px-2 pt-2 pb-1">
              <button type="button" class="section-toggle d-flex align-items-center justify-content-between w-100"
                      (click)="toggleSection('operations')" [attr.aria-expanded]="sectionsOpen.operations">
                <small>Operations</small>
                <i class="bi section-chevron"
                   [class.bi-chevron-down]="sectionsOpen.operations"
                   [class.bi-chevron-right]="!sectionsOpen.operations"></i>
              </button>
            </li>
            @if (isSectionOpen('operations')) {
              <li class="nav-item">
                <a routerLink="/admin/clients" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="All Clients">
                  <i class="bi bi-person-lines-fill fs-5 flex-shrink-0"></i>
                  <span>All Clients</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/client-status" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Client Status">
                  <i class="bi bi-activity fs-5 flex-shrink-0"></i>
                  <span>Client Status</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/site-leads" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2"
                   [title]="availableLeads ? 'Employer Leads — ' + availableLeads + ' not claimed' : 'Employer Leads'">
                  <div class="position-relative flex-shrink-0 d-flex">
                    <i class="bi bi-megaphone fs-5"></i>
                    @if (availableLeads > 0 && sidebarCollapsed) {
                      <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger leads-dot">{{ availableLeads > 99 ? '99+' : availableLeads }}</span>
                    }
                  </div>
                  <span class="flex-grow-1">Employer Leads</span>
                  @if (availableLeads > 0) {
                    <span class="badge rounded-pill bg-danger leads-count">{{ availableLeads > 99 ? '99+' : availableLeads }}<span class="visually-hidden"> not claimed</span></span>
                  }
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/products" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Products">
                  <i class="bi bi-box-seam-fill fs-5 flex-shrink-0"></i>
                  <span>Products</span>
                </a>
              </li>
            }
            <!-- ── Admin: Administration ── -->
            <li class="nav-section-label px-2 pt-2 pb-1">
              <button type="button" class="section-toggle d-flex align-items-center justify-content-between w-100"
                      (click)="toggleSection('administration')" [attr.aria-expanded]="sectionsOpen.administration">
                <small>Administration</small>
                <i class="bi section-chevron"
                   [class.bi-chevron-down]="sectionsOpen.administration"
                   [class.bi-chevron-right]="!sectionsOpen.administration"></i>
              </button>
            </li>
            @if (isSectionOpen('administration')) {
              <li class="nav-item">
                <a routerLink="/admin/user" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="User Management">
                  <i class="bi bi-person-gear fs-5 flex-shrink-0"></i>
                  <span>User Management</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/system-logs" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="System Logs">
                  <i class="bi bi-terminal fs-5 flex-shrink-0"></i>
                  <span>System Logs</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/agency/add" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Agencies">
                  <i class="bi bi-building fs-5 flex-shrink-0"></i>
                  <span>Agencies</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/affiliates" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Affiliates">
                  <i class="bi bi-people fs-5 flex-shrink-0"></i>
                  <span>Affiliates</span>
                </a>
              </li>
            }
          }

          <!-- ── Reports (Admin only) ── -->
          @if(user.securityLevel >= adminLevel) {
            <li class="nav-section-label px-2 pt-2 pb-1">
              <button type="button" class="section-toggle d-flex align-items-center justify-content-between w-100"
                      (click)="toggleSection('reports')" [attr.aria-expanded]="sectionsOpen.reports">
                <small>Reports</small>
                <i class="bi section-chevron"
                   [class.bi-chevron-down]="sectionsOpen.reports"
                   [class.bi-chevron-right]="!sectionsOpen.reports"></i>
              </button>
            </li>
            @if (isSectionOpen('reports')) {
              <li class="nav-group-label px-3 pt-1 pb-1">
                <small class="text-white-50 text-uppercase" style="font-size:0.68rem; letter-spacing:0.04em;">Executive</small>
              </li>
              <li class="nav-item">
                <a routerLink="/reports/business-intelligence" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Business Overview">
                  <i class="bi bi-bar-chart-line-fill fs-5 flex-shrink-0"></i>
                  <span>Business Overview</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/payments-collections" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Payments & Collections">
                  <i class="bi bi-cash-stack fs-5 flex-shrink-0"></i>
                  <span>Payments &amp; Collections</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/cash-reconciliation" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Cash Reconciliation">
                  <i class="bi bi-bank fs-5 flex-shrink-0"></i>
                  <span>Cash Reconciliation</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/coverage-report" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Coverage & Membership">
                  <i class="bi bi-shield-check fs-5 flex-shrink-0"></i>
                  <span>Coverage &amp; Membership</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/provider-financials" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Provider Financials">
                  <i class="bi bi-cash-coin fs-5 flex-shrink-0"></i>
                  <span>Provider Financials</span>
                </a>
              </li>

              <li class="nav-group-label px-3 pt-2 pb-1">
                <small class="text-white-50 text-uppercase" style="font-size:0.68rem; letter-spacing:0.04em;">Operations</small>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/provider-tracking" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Provider Tracking">
                  <i class="bi bi-send-check fs-5 flex-shrink-0"></i>
                  <span>Provider Tracking</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/seller-requests" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Requests & Approvals">
                  <i class="bi bi-inbox-fill fs-5 flex-shrink-0"></i>
                  <span>Requests &amp; Approvals</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/admin/outbox-monitor" routerLinkActive="active"
                   class="nav-link text-white d-flex align-items-center gap-2" title="Delivery Monitor">
                  <i class="bi bi-arrow-repeat fs-5 flex-shrink-0"></i>
                  <span>Delivery Monitor</span>
                </a>
              </li>
            }
          }

        </ul>

        <!-- ── User footer ── -->
        <div class="border-top border-secondary pt-3 pb-3 mt-auto">
          <div class="user-footer d-flex align-items-center gap-2">
            <img src="img/userIcon.png" alt="user" width="32" height="32" class="rounded-circle flex-shrink-0">
            <div class="lh-sm flex-grow-1 overflow-hidden sidebar-user-info">
              <div class="fw-semibold small text-truncate">{{user.firstName}} {{user.lastName}}</div>
              <div class="opacity-50" style="font-size: 0.7rem">
                @if(user.idUserRole == userrole_salesPerson) {
                  Sales Agent
                } @else if(user.idUserRole == userrole_employer) {
                  Employer
                } @else {
                  Administrator
                }
              </div>
            </div>
            <button class="btn btn-signout btn-change-password flex-shrink-0" (click)="openChangePasswordModal()" title="Change password">
              <i class="bi bi-key fs-5"></i>
            </button>
            <button class="btn btn-signout flex-shrink-0" (click)="logout()" title="Sign out">
              <i class="bi bi-box-arrow-right fs-5"></i>
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- ===== CONTENIDO PRINCIPAL ===== -->
    <!-- Escritorio: header y footer fijos, solo .app-main hace scroll (el menú tiene el suyo).
         Móvil: scrollea la columna completa con el header sticky; el footer queda al final. -->
    <div class="col main-column d-flex flex-column" [class.has-chat]="chatWidgetActive">

      <!-- Header: hamburger (móvil) + título + bell + logo -->
      <div class="row align-items-center app-header pt-3 pb-2 border-bottom">
        <div class="col-auto d-md-none">
          <button class="btn btn-dark" type="button"
                  data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu">
            <i class="bi bi-list fs-4"></i>
          </button>
        </div>
        <div class="col">
          <h3 class="mb-0"><strong>{{title}}</strong> - <small class="text-body-secondary">{{subtitle}}</small></h3>
        </div>
        @if(user.securityLevel >= salesLevel) {
          <div class="col-auto pe-1">
            <app-notification-bell />
          </div>
        }
        @if(user.securityLevel == adminLevel) {
          <div class="col-auto pe-1">
            <app-version-info />
          </div>
        }
        <div class="col-auto">
          <img class="img-fluid" src="img/Logo.png" style="max-height: 50px;">
        </div>
      </div>

      <div class="app-main pt-3 pb-3">
        <div class="row">
          <div class="col-12">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

      <!-- ===== FOOTER ===== -->
      <footer class="app-footer border-top d-flex flex-wrap justify-content-center align-items-center column-gap-2 py-1 small text-muted">
        <span>&copy; {{currentYear}} Alliant Federation, LLC &mdash; All rights reserved.</span>
        <span aria-hidden="true">&middot;</span>
        <button type="button" class="btn btn-link btn-sm p-0 text-muted small align-baseline"
                (click)="showTermsModal = true">
          Terms and Conditions
        </button>
      </footer>

    </div>

  </div>
</div>

<!-- ===== CHANGE PASSWORD MODAL ===== -->
@if(showChangePasswordModal) {
  <div class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" style="background: #0E2347; color: #fff;">
          <h5 class="modal-title fw-bold">
            <i class="bi bi-key me-2"></i>Change Password
          </h5>
          <button type="button" class="btn-close btn-close-white" (click)="closeChangePasswordModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body" [formGroup]="changePasswordForm">
          @if(changePasswordError) {
            <div class="alert alert-danger py-2 small">{{ changePasswordError }}</div>
          }
          <div class="mb-3">
            <label class="form-label fw-semibold">Current Password</label>
            <input type="password" class="form-control" formControlName="currentPassword"
                   [class.is-invalid]="changePasswordForm.controls.currentPassword.touched && changePasswordForm.controls.currentPassword.invalid">
            @if(changePasswordForm.controls.currentPassword.touched && changePasswordForm.controls.currentPassword.hasError('required')) {
              <div class="invalid-feedback">Current password is required.</div>
            }
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">New Password</label>
            <input type="password" class="form-control" formControlName="newPassword"
                   [class.is-invalid]="changePasswordForm.controls.newPassword.touched && changePasswordForm.controls.newPassword.invalid">
            @if(changePasswordForm.controls.newPassword.touched) {
              @if(changePasswordForm.controls.newPassword.hasError('required')) {
                <div class="invalid-feedback">New password is required.</div>
              } @else if(changePasswordForm.controls.newPassword.hasError('minlength')) {
                <div class="invalid-feedback">Minimum 8 characters.</div>
              } @else if(changePasswordForm.controls.newPassword.hasError('passwordStrength')) {
                <div class="invalid-feedback">Must include uppercase, lowercase, and a number.</div>
              }
            }
            <div class="form-text">Min. 8 characters with uppercase, lowercase and number.</div>
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Confirm New Password</label>
            <input type="password" class="form-control" formControlName="confirmPassword"
                   [class.is-invalid]="changePasswordForm.controls.confirmPassword.touched && (changePasswordForm.controls.confirmPassword.invalid || changePasswordForm.hasError('passwordsMismatch'))">
            @if(changePasswordForm.controls.confirmPassword.touched && changePasswordForm.hasError('passwordsMismatch')) {
              <div class="invalid-feedback">Passwords do not match.</div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeChangePasswordModal()" [disabled]="changePasswordLoading">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="submitChangePassword()"
                  [disabled]="changePasswordForm.invalid || changePasswordLoading">
            @if(changePasswordLoading) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            Update Password
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ===== TERMS MODAL ===== -->
@if(showTermsModal) {
  <div class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" style="background: #1a6bb5; color: #fff;">
          <div>
            <h5 class="modal-title fw-bold">Terms and Conditions of Enrollment &amp; Use</h5>
            <p class="mb-0" style="font-size: 0.75rem; color: rgba(255,255,255,0.75);">
              Effective Date: 05/15/2024 &mdash; Alliant Federation, LLC
            </p>
          </div>
          <button type="button" class="btn-close btn-close-white ms-3"
                  (click)="showTermsModal = false" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
          <app-terms-offcanvas language="en" [inModal]="true" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary w-100"
                  (click)="showTermsModal = false">
            Understood, close
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ===== CHAT DE AYUDA — solo staff (securityLevel >= salesLevel), activo vía HELPER_CHAT_ACTIVE ===== -->
@if(chatWidgetActive) {
  <app-chat-widget />
}
